export default "<router-outlet></router-outlet>\n<app-loader [showLoader]=\"loaderShow\"></app-loader>\n"